import { styled } from '@nexelem/deprecated-theme';
import { Slide, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const StyledToastProvider = styled(ToastContainer)(() => {
  return {
    '&&&.Toastify__toast-container': {
      minWidth: '100%',
      //theme and spacing not used deliberately as I'm getting an TS error when trying to use MUI useTheme():
      // probably conflict between react-toastify Theme and MUI Theme
      padding: 0,
      marginBottom: '40px',
      pointerEvents: 'none',
    },

    '.Toastify__toast': {
      width: 'fit-content',
      padding: 0,
      backgroundColor: 'transparent',
      boxShadow: 'none',
      marginBottom: 0,
      marginLeft: 'auto',
      marginRight: 'auto',
      pointerEvents: 'auto',
    },
  };
});

export const CustomToastProvider = () => (
  <StyledToastProvider
    newestOnTop
    autoClose={6000}
    closeButton={false}
    closeOnClick={false}
    hideProgressBar={true}
    position="bottom-center"
    transition={Slide}
  />
);
